import React from "react";
import "./index.css";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonCircle = props => {

  const { title, icon, onClick } = props;

  return (
    <Tooltip
      placement="topLeft"
      title={title}
      color={"rgb(0, 80, 117)"}
    >
      <div className="TS-button-circle" onClick={() => onClick && onClick()}>
        <FontAwesomeIcon
          icon={["far", icon || "plus"]}
          style={{ fontSize: "23px", color: "white", margin: "0 auto" }}
        />
      </div>
    </Tooltip>
  );
};

export default ButtonCircle;